import { createStrings } from '@utils/local';

export const preAlertStrings = createStrings({
  ja: {
    companyName: '会社名',
    d2dNo: 'D2D番号',
    doStatus: 'D/O手配',
    eta: 'ETA',
    etd: 'ETD',
    invoice: '請求書',
    invoiceAmount: '税抜請求金額',
    job_code: '台帳番号',
    moveOutStatus: '出庫手配',
    paymentAmount: '税抜支払金額',
    paymentSlip: '支払伝票',
    pod: 'POD',
    pol: 'POL',
    profit: '利益',
    quantity: 'Quantity',
    quantity_ja: '個数',
    memberSalesperson: '営業担当者',
    salespersonChina: 'CS(CN)',
    salespersonJapan: 'CS(JP)',
    preAlert: 'PRE ALERT',
    delivery_date: 'お届け日',
    tagSearchInputPlaceholder: 'D2D番号、POLやPODなどの検索条件を入力してください',
    customer_no: 'お客様の管理番号',
    refer_number: 'Refer Number',
    carrier: 'Carrier',
    shipper: 'Shipper',
    consignee: 'Consignee',
    house_bl_number: 'HBL',
    shipping_mark: 'Shipping Mark',
    commodity: 'Commodity',
    gross_weight: 'Gross Weight',
    measurement: 'Measurement',
    payments_terms: 'Payments Terms',
    is_ledger_locked: 'ロック',
    sea_bl_file: '海上B/L',
    errorCannotLockLedgerLock:
      '税抜請求総額と税抜支払総額が確定していないため、ロックをかけることはできません。',
    errorNoAuthLockLedgerLock: 'FC Japanとadminのみは小ロックをかけできます。',
    errorNoAuthUnlockLedgerLock: 'ロックを解除できるのはadminのみです。',
    warningLockLedgerLock:
      '本当にロックをかけますか？ロックをかけた後、案件は変更できません。ロックの解除はadminのみが行えます。',
    warningUnlockLedgerLock: '本当にadminの権限でロックを解除しますか？',
    errorLedgerLocked: 'ロックはかけられました。ロックの解除はadminにご連絡ください。',
  },
});

export const preAlertStringsCN = createStrings({
  'zh-cn': {
    tagSearchInputPlaceholder: '请选择D2D番号、CNEE或者POL等作为检索条件，再输入内容进行搜索',
  },
});
